import React, { useEffect } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

import * as Styles from './ProjectModalElements';

const ProjectModal = ({ project = {}, onClose = () => {}, ...rest }) => {
  const { displayTitle, subTitle, description, tags, images } = project;

  useEffect(() => {
    disableBodyScroll(document.body);

    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  const handleClose = () => {
    onClose();
  };

  return (
    <Styles.ModalBackDrop onClick={handleClose}>
      <Styles.Modal onClick={(event) => event.stopPropagation()} {...rest}>
        <Styles.ModalHeader>
          <div>
            <Styles.ModalHeaderTitle>{displayTitle}</Styles.ModalHeaderTitle>
            <Styles.ModalHeaderSubTitle>{subTitle}</Styles.ModalHeaderSubTitle>
          </div>
          <Styles.ModalHeaderCloseIcon onClick={handleClose} />
        </Styles.ModalHeader>
        <Styles.ModalBody>
          {images.map((img, idx) => (
            <Styles.ProjectImg
              src={img}
              alt={`${displayTitle}-${idx}`}
              loading="lazy"
            />
          ))}
          <Styles.DescriptionHeading>
            Project Description
          </Styles.DescriptionHeading>
          <Styles.Tags>
            {tags.map((tag) => (
              <Styles.Tag key={tag}>{tag}</Styles.Tag>
            ))}
          </Styles.Tags>
          <Styles.DescriptionText>{description}</Styles.DescriptionText>
        </Styles.ModalBody>
      </Styles.Modal>
    </Styles.ModalBackDrop>
  );
};

export default ProjectModal;
